(function ($, Backbone, app, api) {
	var currentLanguageID;

	var Switcher = Backbone.View.extend({
		el: '.lang-switch',
		events: {
			'click .lang-switch_lang-name': 'switchLang'
		},
		initialize: function () {
			_.bindAll(this);
			if (app.GlobalSettings.Country.Languages.length > 1) {
				this.selectedClass = 'lang-switch_lang-name__selected';
				this.$languages = this.$('.lang-switch_lang-name');
				this.$el.show();
				_.each(app.GlobalSettings.Country.Languages, this.renderLang);
			} else {
				this.$el.remove();
			}
		},
		renderLang: function (lang, i) {
			var $langNode = this.$languages.eq(i),
				id = lang.ID.toLowerCase();
			$langNode.attr('id', id);
			if (id === currentLanguageID) {
				$langNode.addClass(this.selectedClass);
				this.$current = $langNode;
			}
		},
		switchLang: function (e) {
			var $clickedLang = $(e.target);
			if ($clickedLang.is(this.$current)) return;
			this.$current.removeClass(this.selectedClass);
			$clickedLang.addClass(this.selectedClass);
			this.$current = $clickedLang;
			api.setUserLanguage($clickedLang.attr('id')).done(function () {
				location.reload(true);
			});
		}
	});

	$(function () {
		currentLanguageID = app.cookie.get('ul') || 'en';
		new Switcher();
	});
})(jQuery, Backbone, app, api);